import ThisModule from "./ModalCropper";

export default ThisModule;
